// Using the browser specific directory router instance to assist builds to be faster
import { Router } from 'director-fork/build/director';

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Function Router called at module scope is not allowed. This may cause unwanted side effects. */
const router: Router = new Router();
export default router;

/** Gets an array with the current route segments, including the vdir. */
export function getCurrentRoute(): string[] {
    return router.getRoute();
}
